import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { ISpontaneitySignUpTrackingData } from './models/ISpontaneitySignUpTrackingData'

export function spontaneitySignUp() {
  const metrics = getMetrics()
  return metrics.api.track(EventTypes.SPONTANEITY_SIGNUP, getSignUpData())
}

function getSignUpData(): ISpontaneitySignUpTrackingData {
  const state = Object.assign({}, store.getState())
  return {
    value: 1,
    name: 'spontaneity signup',
    category: 'spontaneity',
    country: state.locale.country,
  }
}

export function FacebookSpontaneitySignup(
  data: ISpontaneitySignUpTrackingData,
): any {
  return {
    value: data.value,
    content_name: data.name,
    content_category: data.category,
  }
}

export function AdWordsSpontaneitySignup(
  data: ISpontaneitySignUpTrackingData,
): any {
  return {
    sendTo: '6kY3CI-snYMBEPn5ucwD',
    value: 1,
  }
}

export function GoogleSpontaneitySignup(
  data: ISpontaneitySignUpTrackingData,
): any {
  return {
    event_category: data.category,
  }
}

export function SnapchatSpontaneitySignup(
  data: ISpontaneitySignUpTrackingData,
): any {
  return {}
}
